import './interceptors'
import $http from 'axios'
require('promise.prototype.finally').shim()


export default {
    $http: $http,
    base: require('./base').default($http),
}


// WEBPACK FOOTER //
// ./src/api/index.js